import {useMemo, useState} from 'react'

type Sort<T> = {key: keyof T; order: 'asc' | 'desc'} | null

// Ordenação só em tela: crescente -> decrescente -> ordem original do backend.
const useTableSort = <T>(list: T[]) => {
  const [sort, setSort] = useState<Sort<T>>(null)

  const toggleSort = (key: keyof T) =>
    setSort((current) => {
      if (current?.key !== key) {
        return {key, order: 'asc'}
      }

      return current.order === 'asc' ? {key, order: 'desc'} : null
    })

  const rows = useMemo(() => {
    if (!sort) {
      return list
    }

    return [...list].sort((a, b) => {
      const first = a[sort.key]
      const second = b[sort.key]
      const result =
        typeof first === 'number' && typeof second === 'number'
          ? first - second
          : String(first).localeCompare(String(second), 'pt-BR')

      return sort.order === 'asc' ? result : -result
    })
  }, [list, sort])

  // Classe do Metronic que exibe a seta de ordenação no cabeçalho.
  const sortClass = (key: keyof T) => (sort?.key === key ? `table-sort-${sort.order}` : undefined)

  return {rows, toggleSort, sortClass}
}

export {useTableSort}
